// FIXME: figure out better typed solution
const getEntityFields = (node: any) => {
  const { entityMetatags, entityTranslations } = node;

  const combinedTranslations = entityTranslations || [];

  return {
    entityMetatags,
    // we have to cast this to Drupal_Node to include the extra fields
    // that are added in the query based on Drupal_Node values
    entityTranslations: combinedTranslations as any[]
  };
};

export default getEntityFields;
